import styled from 'styled-components';

export const ReportContainer = styled.div`
  padding: 40px 0;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
`;

export const LoadingText = styled.div`
  text-align: center;
  font-size: 18px;
  color: #666;
  margin: 40px 0;
`;

export const ErrorText = styled.div`
  text-align: center;
  font-size: 18px;
  color: #d32f2f;
  margin: 40px 0;
`;

export const Background = styled.div`
  width: 100%;
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: fit-content;
`;

export const LeftSide = styled.div`
  width: 100%;
`;

export const RightSide = styled.div`
  float: right;
`;
